import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function getRolesBonifications(sale_type) {
   
    const response = await axios.get(
        `${REACT_APP_API}/bonifications/role/sale_type?sale_type=${sale_type}`
    )
    
    return response?.data?.data
}
